var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageSection',{class:_vm.$style.csrWhy,attrs:{"use-alternate-bg-color":_vm.useAlternateBgColor}},[_c('PageContainer',[_c('PageTwoColumnsContent',{attrs:{"image":_vm.items.image,"content":_vm.items.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }